import { ActionIcon, Text, Tooltip } from '@mantine/core'
import { alertStatus } from 'data/alertStatus'
import { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'
import { TbEdit } from 'react-icons/tb'
import { TAlertStatus } from 'shared/types'
import { openAlertStatusModal } from './ChangeAlertStatus'
import { StatusBadge } from 'components/common/StatusBadge'

export const AlertStatusBadge = ({
  status,
  disableEdit,
  alertId,
}: {
  status: TAlertStatus
  disableEdit?: boolean
  alertId: string
}) => {
  const { t } = useTranslation()

  const statusObj = alertStatus(t).get(status)

  if (statusObj === undefined) return <Text>{status}</Text>

  const { color, label, icon: Icon } = statusObj
  const canEdit = status !== 'Normalized' && !disableEdit
  const rightSection = canEdit ? (
    <Tooltip label={t('alert.changeStatus')}>
      <ActionIcon
        aria-label={t('alert.changeStatus')}
        color={color}
        onClick={(e: MouseEvent<HTMLButtonElement>) => {
          e.stopPropagation()
          openAlertStatusModal(alertId)
        }}
        radius="xl"
        size="xs"
        title={t('alert.changeStatus')}
        variant="subtle"
      >
        <TbEdit size="0.875rem" />
      </ActionIcon>
    </Tooltip>
  ) : undefined

  return (
    <StatusBadge rightSection={rightSection} color={color} icon={<Icon />}>
      {label}
    </StatusBadge>
  )
}
